import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { DateService } from "@app/core/services/date/date.service";
import { Action } from "@app/models";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { Observable, switchMap } from "rxjs";
import { ActionListItemService } from "../../services/action-list-item.service";

@Component({
  selector: "action-task-connected",
  template: `
    <div class="display-flex-start">
      <span [innerHTML]="text | async" class=""></span>&nbsp;
      <contact-summary [contactId]="item.contactId"></contact-summary>
    </div>
    <div>
      <small *ngIf="item.param2?.length > 0" class="text-muted">
        <strong>{{ "type" | translate }}: </strong>{{ item.param2 }}
      </small>
    </div>
  `,
  styleUrls: ["./common.scss"],
})
export class ActionTaskConnectedComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() item: Action;

  text: Observable<string>;
  listenerTask: Function;
  listenerName: Function;

  classTask = "action-task-connected-task";

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private ts: TranslateService,
    public itemService: ActionListItemService,
    private dateUtilService: DateService
  ) {}

  ngOnInit() {
    const inPastTense = this.dateUtilService.expired(this.item.param3);
    const translationKey =
      "action_task_connected_text" + (inPastTense ? "_past" : "");

    this.text = this.itemService.getMeTranslation(this.item).pipe(
      switchMap((meString: string) =>
        this.ts.get(translationKey, {
          task: `<span class="${this.classTask} text-link">${this.item.param1}</span>`,
          name: meString,
          fromNow: moment(this.item.param3).fromNow(),
        })
      )
    );
  }

  ngAfterViewInit() {
    this.listenerTask = this.itemService.createTaskLinkListener(
      this.elementRef,
      this.renderer,
      this.classTask,
      this.item
    );
  }

  ngOnDestroy() {
    const listeners = [this.listenerTask, this.listenerName];
    listeners.forEach((listener: Function) => {
      if (listener) {
        listener();
      }
    });
  }
}
